<template>
    <v-layout wrap>
        <v-flex xs12>
            <v-combobox
                ref="searchInput"
                :readonly="defaultAppointment !== undefined && defaultAppointment !== null"
                flat
                :clearable="!defaultAppointment"
                outline
                v-model="model"
                :disabled="loading"
                :items="items"
                :loading="loading"
                :search-input.sync="search"
                autofocus
                :filter="() => true"
                color="primary"
                hide-no-data
                item-text="title"
                item-value="id"
                label="Buscar servicio o especialista"
                :placeholder="!loading && schedules.length === 0 ? 'El proveedor no ha creado agendas' : 'Ej. Médico, Juan Perez...'"
                @click:clear="clearSearch"
                return-object
            >
                <template slot="no-data">
                    <span class="caption pa-2">No se han encontrado servicios / especialistas</span>
                </template>

                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                        <schedule-list-item :schedule="data.item"/>
                    </template>
                </template>
            </v-combobox>
        </v-flex>
        <v-flex v-if="showCard && model && typeof model === 'object'">
            <v-slide-y-transition>
                <v-flex xs12 v-if="model" v-show="model">
                    <schedule-list-item :schedule="model"/>
                </v-flex>
            </v-slide-y-transition>
        </v-flex>
    </v-layout>
</template>

<script>

import SpecialistStats from '@/components/specialists/SpecialistStats'
import ScheduleListItem from './ScheduleListItem.vue'

import {ApiUtils} from '@/utils/ApiUtils'
import {debounce} from '@/utils/Common'

import {mapMutations, mapState} from 'vuex'

export default {
    props: ['onSelect', 'onClear', 'showCard', 'autoFocus', 'provider', 'internal', 'defaultAppointment', 'individualProvider', 'branchOffice'],
    components: {
        SpecialistStats,
        ScheduleListItem
    },
    data() {
        return {
            descriptionLimit: 60,
            schedules: [],
            loading: false,
            search: '',
            model: null,
        }
    },
    mounted() {
        this.getSchedules()
        this.setDefaultSchedule()
    },
    computed: {
        ...mapState(['currentBranchOffice']),
        currentOffice() {
            const vm = this
            return vm.branchOffice || vm.currentBranchOffice
        },
        items() {
            return this.schedules.map(schedule => {
                schedule.title = schedule.specialist ? `${schedule.specialist.first_name} ${schedule.specialist.last_name}` :
                    `${schedule.service_item.service.name} | ${schedule.service_item.description}`
                return schedule
            })
        },
        currentScheduleId() {
            const vm = this
            return vm.$route.query.schedule || null
        }
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        reset() {
            var vm = this
            vm.search = ''
            vm.model = null
        },
        triggerSearch() {
            var vm = this
            if (vm.search && vm.search.length > 0) {
                vm.debounceGetSchedules()
            }

        },
        filter: (item, queryText, itemText) => {

            return true

            if (typeof item.first_name == 'undefined' || typeof item.specialty == 'undefined') {

                if (typeof item.header !== 'undefined') {
                    return item.header.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
                }

                return false
            }

            return item.first_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
                item.specialty.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        },
        debounceGetSchedules: debounce(function () {
            this.getSchedules()
        }, 300),
        async getSchedules() {

            var vm = this

            if (vm.loading) return

            if (vm.model && vm.search === vm.model.title) return
            vm.loading = true

            var url
            const prefix = vm.internal ? '' : 'public/'
            if (vm.individualProvider === true) {
                url = `${prefix}provider/${vm.provider}/schedules`
            } else {
                const office = vm.currentOffice
                url = `${prefix}provider/${vm.provider}/branch-office/${office.id}/schedules`
            }

            var response = await ApiUtils.makeGet(url, {
                term: vm.search,
                active_only: 1
            })
            vm.loading = false

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar agendas')
                return
            }

            const json = await response.json()
            if (json.result.schedules.data.length === 0) vm.showSnackBar('No se han encontrado  agendas')
            vm.schedules = json.result.schedules.data
            vm.$nextTick(function () {
                if (vm.defaultAppointment && vm.defaultAppointment.schedule) {

                    const foundSchedule = vm.schedules.find(schedule => {
                        return schedule.id === vm.defaultAppointment.schedule.id
                    })

                    if (foundSchedule) {
                        vm.model = foundSchedule
                    }

                }
            })

        },
        clearSearch() {
            var vm = this
            vm.search = ''
            if (typeof vm.onClear == 'function') {
                vm.onClear()
            }
        },
        setDefaultSchedule() {
            const vm = this
            if (!vm.currentScheduleId) return;
            vm.model = vm.items.find(item => item.id === Number(vm.currentScheduleId))
        }
    },
    watch: {
        currentOffice() {
            const vm = this
            vm.reset()
        },
        search(val) {
            var vm = this
            vm.debounceGetSchedules()
        },
        schedules(val) {
            if (val && val.length === 1) {
                this.model = val[0]
            }
        },
        model(val) {
            this.$emit('change', val)
        },
        defaultAppointment(val) {

            var vm = this

            if (!val || !val.schedule) {
                vm.model = null
                return
            }

            const foundSchedule = vm.schedules.find(schedule => {
                return schedule.id === val.schedule.id
            })

            if (foundSchedule) {
                vm.model = foundSchedule
            }
        },
        items() {
            this.setDefaultSchedule()
        }
    }
}
</script>